<template>
    <div>

        <b-row align-v="center" class="report-chart-block">

            <!-- Max, Min 多參數圖 -->
            <b-col class="col-12 col-lg-8">

                <div class="report-chart-title">
                    {{ $t('report.ui.daily') }} {{ $t('sensor.soil_temperature') }} {{ $t('report.ui.chart') }}
                </div>
                <div class="device">
                    <div class="device-sensor-blocks">
                        {{ $t('sensor.soil_temperature') }}<div class="device-unit" v-html="$t('sensor.u_soil_temperature')"></div>
                    </div>
                </div>

                <div class="print-chart-scroll">
                    <div class="print-chart-area">
                        <MixChartMinMaxParamData v-if="timeData['day']" :chartID="'device-chart-soil_temperature-' + deviceHashid + '-001'"
                                            :info_type="'report'"
                                            :time="timeData['day']"
                                            :dataList="deviceData"
                                            :dataDisplaySettings="dataDisplaySettings"
                                            :chartTitle="'Report Soil Temperature'"
                                            :showToolbox="true"
                                            :showDeviceName="false"
                                            :rightToolbox="false"
                                            :xAxisName="'date'" :xAxisFormat="'MM/DD'"
                        ></MixChartMinMaxParamData>
                    </div>
                </div>
            </b-col>
            <b-col class="col-12 col-lg-4">
                <b-alert show variant="success">
                    <h4 class="">
                        <i :class="$tools.style.classIcon(deviceInfo.type, 'block-title')"></i>
                        <div class="block-text">{{ deviceInfo.nickname }}</div>
                        <div class="block-text">( {{ deviceHashid }} )</div>
                    </h4>
                    <div>
                        <div class="block-text">{{ $t('sensor.avg_daily_low_soil_temp') }} ：</div>
                        {{ deviceData.avg_daily_low_soil_temp }} {{ $t('sensor.u_avg_daily_low_soil_temp') }}
                    </div>
                    <div>
                        <div class="block-text">{{ $t('sensor.avg_daily_high_soil_temp') }} ：</div>
                        {{ deviceData.avg_daily_high_soil_temp }} {{ $t('sensor.u_avg_daily_high_soil_temp') }}
                    </div>
                    <div>
                        <div class="block-text">{{ $t('sensor.avg_daily_soil_temp') }} ：</div>
                        {{ deviceData.avg_daily_soil_temp }} {{ $t('sensor.u_avg_daily_soil_temp') }}
                    </div>
                    <div>
                        <div class="block-text">{{ $t('sensor.avg_daily_diff_soil_temp') }} ：</div>
                        {{ deviceData.avg_daily_diff_soil_temp }} {{ $t('sensor.u_avg_daily_diff_soil_temp') }}
                    </div>
                </b-alert>
            </b-col>

        </b-row>

    </div>
</template>

<script>
import ecTools from '@/echarts/echarts-tools'
// import MixChartMultipleParams from '@/views/echarts/MixChart_MultipleParams'
import MixChartMinMaxParamData from '@/views/echarts/MixChart_MinMaxParamData'

export default {
    props: {
        deviceHashid: {
            type: String,
            required: true,
        },
        deviceData: {
            type: Object,
            required: true,
        },
        deviceInfo: {
            type: Object,
            default: {},
        },
        timeData: {
            type: Object,
            default: function () { return {} }
        },
        dataDisplaySettings: {
            type: Array,
            default: function () { return [] }
        },
    },
    components: {
        // MixChartMultipleParams,
        MixChartMinMaxParamData,
    },
    data () {
        return {
        }
    },
    mounted ()
    {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>

</style>